import * as Yup from "yup";

export const validationSchema = Yup.object({
  fullName: Yup.string().required("Full Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string().required("Phone number is required"),
  state: Yup.string().required("State is required"),
  city: Yup.string().required("City is required"),
  companyName: Yup.string().required("Company Name is required"),
});

export const RemarkValidation = Yup.object({
  remark: Yup.string().required("Remark is required"),
});